/** API route map: URLS.Controller.PaycheckCalculator */
export const PaycheckCalculator = {
      Name: 'PaycheckCalculator/',
      GetClientPositions: 'get-client-positions',
      GetClientPayCodes: 'get-client-pay-codes',
      GetClientDeductionCodes: 'get-client-deduction-codes',
};
